import { Component, createRef } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faLongArrowUp } from '@fortawesome/pro-light-svg-icons/faLongArrowUp';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';

import Preloader from '../../Preloader';
import StoryCard from '../../TrendingStories/StoryCard';
import Tooltip from '../../Tooltip';

import { getTrendingBarAssetQuery } from '../../../helpers/watchlistHelperFunctions';
import withComponentName from '../../../decorators/withComponentName';

import * as searchActions from '../../../actions/searchActions';
import * as watchlistActions from '../../../actions/watchlistActions';
import * as trendingActions from '../../../actions/trendingBarActions';
import * as storyActions from '../../../actions/stories.actions';

import noStoriesImg from '../../../assets/watchlist/few-stories-icon-copy-4.svg';

import permissionsDecorator from '../../../decorators/permissionsDecorator';

import { SILVER, GOLD } from '../../../data/permissions';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class TrendingTopicItem extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      popoverOpen: false,
    };
    this.trendingTopic = createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      activeTopicItem,
      width,
      handleActiveTrendingTopicItem,
      id,
    } = this.props;

    if (prevProps.width !== width && width >= 1023) {
      this.setState({ popoverOpen: false });
      handleActiveTrendingTopicItem(id, false);
    }

    if (prevProps.activeTopicItem !== activeTopicItem && activeTopicItem === null) {
      this.closePopover();
    }
  }

  closePopover() {
    const {
      similarStoriesModalOpened, actions,
      handleActiveTrendingTopicItem, id,
      storyImageOpened,
    } = this.props;

    if (!similarStoriesModalOpened && !storyImageOpened) {
      actions.closeTrendingDropDowns();
      this.setState({
        popoverOpen: false,
      });
      handleActiveTrendingTopicItem(id, false);
    }
  }

  togglePopover() {
    const {
      openModal,
      actions,
      topic,
    } = this.props;
    const { popoverOpen } = this.state;

    if (openModal) return;

    if (!popoverOpen) actions.closeTrendingDropDowns();

    this.setState({
      popoverOpen: !popoverOpen,
    }, () => {
      // eslint-disable-next-line no-shadow
      const { popoverOpen } = this.state;
      const {
        storyFilters, handleActiveTrendingTopicItem, id, period,
      } = this.props;

      handleActiveTrendingTopicItem(id, popoverOpen);

      if (popoverOpen) {
        actions.loadingTrendingBarTopics();

        const query = getTrendingBarAssetQuery(topic, 'Topic');

        // default filter values used here
        const params = {
          categories: 'mp,op,r',
          all_languages: storyFilters.all_languages,
          min_score: 5,
          order_by: 'top',
          time_filter: period,
          limit: 20,
          fold_similar_stories: storyFilters.group_similar_stories,
          query,
          ...(!storyFilters.all_languages && {
            languages: storyFilters.languages,
          }),
        };

        actions.searchTrendingBarStories(params);
      }
    });
  }

  toggleWatchlistModal() {
    const { openWathclistModal, topic, piwikEnabled } = this.props;
    this.setState({
      popoverOpen: false,
    }, () => {
      openWathclistModal(topic);
      if (piwikEnabled) _paq.push(['trackEvent', 'Trending bar', 'Trending add', topic.name]);
    });
  }

  searchPageRedirect() {
    const { topic: { asset_class: assetClass, slug } } = this.props;
    window.location.href = `/news/directory/${assetClass.slug}/${slug}`;
  }

  renderTopics() {
    const {
      trendingBarStories,
      actions,
      user,
      piwikEnabled,
    } = this.props;

    if (trendingBarStories.length) {
      return trendingBarStories.map((story) => (
        <StoryCard
          key={story.id}
          story={story}
          trendingBarCard
          popup // to give current style to list in Popup
          useFoldedSimilarStories
          onFreezeStories={actions.freezeStories}
          expandFilter={false}
          showTranslation={false}
          user={user}
          type={story.type}
          onHide={actions.hideStory}
          piwikEnabled={piwikEnabled}
          onLikeChanged={actions.updateStoriesInfo}
          onBookmarkClick={actions.updateStoriesBookmark}
          isModal
        />
      ));
    }

    return (
      <div className={Styles['no-trending-stories-message']}>
        <img src={noStoriesImg} alt="No Stories" />
        <p>
          Our machines are a little confused.
          They believed this topic was trending, but they can&apos;t find any stories for it!
        </p>
        <p>
          We are working on unconfusing them.
          <br />
          Luckily they learn fast, so this should be corrected shortly.
        </p>
      </div>
    );
  }

  render() {
    const {
      score,
      id,
      topic,
      trendingBarStories,
      loadingTrendingBarTopics,
      permissionsInitialized,
      accessLevels,
      loadingNewTrendingBarTopics,
    } = this.props;
    const { popoverOpen } = this.state;

    const trendingTimes = +((score / 100) + 1).toFixed(2);
    const trendingTimesRounded = (
      Math.round(trendingTimes) > 2 ? Math.round(trendingTimes) : trendingTimes
    );

    const trendingItemClass = cx({
      trending_asset_item: true,
      active: popoverOpen,
      'trending-bar-list-el': true,
    });

    const popoverFooterClass = cx({
      popover_footer: true,
      'bottom-stories-footer': true, // if there are few stories, we make footer fixed to bottom
    });

    const trendingBarStoriesClass = cx({
      trending_bar_stories: true,
      'padding-bottom': true, // also add padding when footer fixed
    });

    return (
      <>
        <li
          className={trendingItemClass}
          onClick={this.togglePopover}
          id={id}
          ref={this.trendingTopic}
        >
          <div className="mr-3">
            <div className={Styles.asset_name}>
              {topic.name}
              <span className={Styles.trend_positive}>
                <FontAwesomeIcon icon={faLongArrowUp} />
                {trendingTimesRounded}
                x
              </span>
            </div>
            <div className={Styles.trending_topic_class}>{topic.asset_class.title}</div>
          </div>
          <FontAwesomeIcon
            icon={popoverOpen ? faAngleUp : faAngleDown}
            className={Styles.asset_dropdown_arrow}
          />
        </li>
        <Overlay
          show={popoverOpen}
          target={this.trendingTopic.current}
          placement="bottom"
          onHide={this.closePopover}
          rootClose
          popperConfig={{
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  padding: 5,
                },
              },
            ],
          }}
        >
          <Popover
            className={cx({ 'popover-no-stories': !trendingBarStories.length })}
            id={cx('trending_bar_popover')}
          >
            <span className={Styles.arrow} />
            <div className={Styles.popover_header}>
              <div className={Styles.add_trending_wl} onClick={this.toggleWatchlistModal}>
                <FontAwesomeIcon icon={faPlusCircle} />
                <p>Add Topic to Watchlist</p>
              </div>
            </div>
            {permissionsInitialized && !accessLevels.includes(GOLD) && (
              <div className={cx('premium-message')}>
                <span className={cx('info-text')}>
                  Premium Content is hidden.
                  <Link
                    to="/pricing"
                    rel="noopener noreferrer"
                  >
                    {' '}
                    Upgrade
                    {' '}
                  </Link>
                  for access.
                </span>
                <Tooltip className={cx('tooltip')}>
                  {!accessLevels.includes(SILVER) && 'Silver and '}
                  Gold subscriptions enable more content.
                  <br />
                  <Link
                    to="/pricing"
                    rel="noopener noreferrer"
                  >
                    See plans
                  </Link>
                  &nbsp;for details.
                </Tooltip>
              </div>
            )}
            <div className={trendingBarStoriesClass}>
              {loadingTrendingBarTopics
                || (loadingNewTrendingBarTopics && !trendingBarStories.length)
                ? (
                  <div className={Styles['trending-bar-preloader-wrapper']}>
                    <Preloader
                      loading
                      color="#f7f7f7"
                    />
                  </div>
                ) : (
                  <>
                    {this.renderTopics()}
                    {loadingNewTrendingBarTopics && (
                      <Preloader
                        loading
                      />
                    )}
                  </>
                )}
              {!loadingTrendingBarTopics && trendingBarStories.length > 0 && (
                <footer
                  className={popoverFooterClass}
                  onClick={this.searchPageRedirect}
                >
                  <p>See More Stories</p>
                  <FontAwesomeIcon icon={faAngleRight} />
                </footer>
              )}
            </div>
          </Popover>
        </Overlay>
      </>
    );
  }
}

const mapStateToProps = ({
  trendingBarReducer,
  watchlistReducer,
  storyFilters,
  stories,
  subscriptions: {
    permissions,
    permissionsInitialized,
  },
  common,
}) => ({
  trendingBarStories: trendingBarReducer.trendingBarStories,
  activeWatchlist: watchlistReducer.activeWatchlist,
  storyFilters,
  loadingTrendingBarTopics: trendingBarReducer.loadingTrendingBarTopics,
  loadingNewTrendingBarTopics: trendingBarReducer.loadingNewTrendingBarTopics,
  permissionsInitialized,
  accessLevels: permissions.access_levels,
  similarStoriesModalOpened: stories.similarStoriesModalOpened,
  storyImageOpened: stories.storyImageOpened,
  width: common.width,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...searchActions,
    ...watchlistActions,
    ...trendingActions,
    ...storyActions,
  }, dispatch),
});

export default withComponentName(connect(
  mapStateToProps,
  mapDispatchToProps,
)(permissionsDecorator(TrendingTopicItem)));
